import type {PosterProductDataForProcessDesign} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';
import type {ReactElement} from 'react';
import React from 'react';
import {Size, Type} from '@Components/button';
import styles from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/publishing-yodeck-panel/publishing-yodeck-panel.module.scss';
import type {VoidFunction} from '@Utils/general.util';
import {CopyLinkButton} from '@Components/copy-link-button/copy-link-button';

export function buildIframeEmbedSnippet(displayCodeGenerated: string, productUsed: PosterProductDataForProcessDesign): string {
  if (productUsed) {
    const {width, height} = productUsed;
    const srcLink = window.PMW.util.site_url(`v/d/`);

    if (typeof srcLink !== 'undefined') {
      return `<iframe width="${width}" height="${height}" src="${srcLink}${displayCodeGenerated}" frameborder="0" allowfullscreen></iframe>`;
    }
  }
  return '';
}

export const useCopyButton = (clicked: boolean, linkToCopy: string, setClicked: (value: React.SetStateAction<boolean>) => void, onCopyClick?: VoidFunction): ReactElement<any> => {
  return (
    <CopyLinkButton
      className={`flex-1 ${styles.noWrapText}`}
      doChangeIconOnCopy
      linkToCopy={linkToCopy}
      buttonProps={{
        type: clicked ? Type.SUCCESS : Type.PRIMARY,
        text: clicked ? window.i18next.t('pmwjs_insights_keywords_copied') : window.i18next.t('pmwjs_copy_link'),
        size: Size.SMALL,
        onClick: () => {
          if (onCopyClick) {
            onCopyClick();
          }
          setClicked(true);
        },
        isActive: false,
      }}
      onCopyFeedbackComplete={() => {
        setClicked(false);
      }}
    />
  );
};
